import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServiceService } from '../../../shared-services/auth-service.service';
import { tap } from 'rxjs/operators';
import { UserDataService } from '../data-storage/user-data.service';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { CanActivate } from '@angular/router';
import { UrlTree } from '@angular/router';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserDto } from '../../../dtos/userDto';

@Injectable({
    providedIn: 'root'
})
export class UserGuard implements CanActivate {

    constructor(private authService: AuthServiceService, private userDataService: UserDataService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.authService
            .getMe()
            .pipe(
                catchError(err => {
                    return of(true);
                }),
                tap((user:UserDto) => {
                    this.userDataService.setUser(user);
                }),
                map(user=> true)
            )
    }
}
